import "./LiquidFiltration.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import LiquidHero from "./sections/LiquidHero";
import ProcessGuide from "./sections/ProcessGuide";
import RelatedArticles from "./sections/RelatedArticles";
import QuoteCTA from "./sections/QuoteCTA";
import Footer from "@/reusable_sections/Footer";
export default function LiquidFiltrationPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="LiquidFiltration" />
      <LiquidHero />
      <ProcessGuide />
      <RelatedArticles />
      <QuoteCTA />
      <Footer />
    </div>;
}